// react
import React, { Component, useEffect } from "react";

// third-party
import { Link } from "react-router-dom";

// application
import departmentsAria from "../../services/departmentsArea";
import languages from "../../i18n";
import StroykaSlick from "../shared/StroykaSlick";
import * as GENERAL from "../../api/general";

const slickSettings = {
    dots: true,
    arrows: false,
    infinite: true,
    // autoplay: true,
    speed: 2500,
    autoplaySpeed: 7000,
    slidesToShow: 1,
    slidesToScroll: 1,
};

class BlockEventSlider extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {}

    render() {
        const { events } = this.props;

        const slides =
            events.length > 0
                ? events.map((event, index) => (
                      <Link key={event.slug} to={"/event-products/" + event.slug} className="block-event__slide">
                          <img className="img-fluid" src={event?.images[0]?.url} />
                      </Link>
                  ))
                : null;

        return events ? (
            <div className="block container pt-5">
                <div className="block-slideshow__body">
                    <StroykaSlick {...slickSettings}>{slides}</StroykaSlick>
                </div>
            </div>
        ) : null;
    }
}

export default BlockEventSlider;
